var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Copyrights © "+_vm._s(_vm.get_year)+" Veo Worldwide Services\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }